export const faqData = [
  {
    question: '亚洲一级日本内容导航是什么？',
    answer: '亚洲一级日本精选内容导航是一个专注于日本文化、影视、美食、旅游等领域的中文内容聚合平台。我们精心筛选和整理日本相关的一级优质资源与内容，帮助用户快速找到所需的分类信息。无论是想了解日本传统文化，还是查找最新的日本影视作品推荐，或者规划一次日本自由行，这里都能为您提供权威、全面的内容指南。'
  },
  {
    question: '网站上的内容多久更新一次？',
    answer: '我们的内容团队保持每日更新频率，确保为您提供最新、最全面的日本相关资讯。每个分类板块都会定期补充新的文章和资源，让您始终获取到第一手的内容。热门话题和季节性内容（如樱花季、红叶季等）我们会在第一时间进行专题更新。'
  },
  {
    question: '如何快速找到我感兴趣的日本内容？',
    answer: '您可以通过首页的分类导航直接进入感兴趣的板块，如日本文化、日本影视、日本美食、日本旅游等。每个分类页面都提供了详细的文章列表和相关资源。此外，网站支持通过标签筛选内容，您也可以使用即将上线的搜索功能进行精确查找。'
  },
  {
    question: '网站的内容来源是否可靠？',
    answer: '所有内容均经过专业编辑团队审核，信息来源包括权威媒体报道、官方发布资料以及资深行业专家的供稿。我们严格把控内容质量，确保每一篇文章都准确、客观、有价值。对于引用的数据和事实，我们会标注来源，让用户可以追溯原始信息。'
  },
  {
    question: '亚洲一级日本和其他日本资讯网站有什么不同？',
    answer: '亚洲一级日本专注于"一级内容"的精选与聚合，不追求数量而是注重质量。我们按照日本文化、影视、美食、旅游、动漫、音乐、时尚、科技八大一级类目进行系统化组织，每个类目下再进行精细分类。这种分层结构让用户能够高效地找到最优质的内容，而不是在海量信息中迷失。'
  },
  {
    question: '我可以通过网站联系到日本当地的资源吗？',
    answer: '我们提供详细的资源导航和联系方式指引，帮助用户对接日本当地的优质资源。无论您是寻找日本旅游地接服务、想购买日本特色商品，还是希望与日本文化机构建立联系，我们的内容指南都能为您指明方向。如有具体需求，也可以通过"关于我们"页面的联系表单与我们取得联系。'
  }
];

export const siteInfo = {
  name: '亚洲一级日本精选内容导航',
  slogan: '汇聚日本优质资源，探索东瀛文化之美',
  description: '亚洲一级日本专题页，汇聚亚洲一级日本相关优质资源与内容指南，帮助用户快速找到亚洲一级日本分类信息，覆盖日本文化、影视、美食、旅游等一级类目，内容权威全面，持续更新。',
  founded: '2024',
  email: 'contact@qtblmpd.cn',
  stats: {
    categories: 8,
    articles: 358,
    monthlyVisitors: 120000,
    satisfactionRate: 98.5
  }
};